export default __webpack_public_path__ + "static/media/ehdo.c6def9c2.jpg";